import { create } from 'zustand';
import {
  AccessibilityCheckerStore,
  IssueCategory,
  IssuesCategoryType,
  SeverityLevel,
} from './AccessibilityChecker.consts';
import { CheckerStatus } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/AccessibilityChecker.consts';

export const useAccessibilityCheckerStore = create<AccessibilityCheckerStore>((set, get) => ({
  accessibilityScore: 0,
  selectedIssueCategory: IssuesCategoryType.COLOR_CONTRAST,
  selectedSeverity: SeverityLevel.CRITICAL,
  status: CheckerStatus.PRESCAN,
  filteredIssues: [],
  recommendations: [],
  issuesCount: 0,
  setAccessibilityData: (data) => {
    const accessibilityScore = data.score * 100;
    const status = accessibilityScore < 90 ? CheckerStatus.FAILED : CheckerStatus.PASSED;
    const filteredIssues =
      data.issues?.[get().selectedSeverity]?.[get().selectedIssueCategory] ?? [];
    set((state) => ({
      ...state,
      status,
      filteredIssues,
      accessibilityScore,
      issuesFound: data.issues,
      issuesCount: data.issuesCount,
      recommendations: data.recommendations,
    }));
  },
  setStatus: (status: CheckerStatus) => {
    set((state) => ({ ...state, status }));
  },
  getSelectedSeverityIndex: () => {
    return Object.values(SeverityLevel).indexOf(get().selectedSeverity);
  },
  selectIssueCategory: (selectedIssueCategory: IssuesCategoryType) => {
    const filteredIssues =
      get().issuesFound?.[get().selectedSeverity]?.[selectedIssueCategory] ?? [];
    set((state) => ({ ...state, selectedIssueCategory, filteredIssues }));
  },
  selectSeverity: (index: number) => {
    const selectedSeverity = Object.values(SeverityLevel)[index];
    const selectedCategory: keyof IssueCategory = get().selectedIssueCategory;
    const filteredIssues = get().issuesFound?.[selectedSeverity]?.[selectedCategory] ?? [];
    set((state) => ({ ...state, selectedSeverity, filteredIssues }));
  },
  getAmountOfIssuePerCategory: (issueCategory: IssuesCategoryType) => {
    const filteredIssues = get().issuesFound?.[get().selectedSeverity]?.[issueCategory] ?? [];
    return filteredIssues.length;
  },
  getAmountOfIssues: () => {
    return get().issuesCount;
  },
  isAuditPassed: () => {
    return get().status === CheckerStatus.PASSED;
  },
}));
